function addEventListenersToPopup() {
    const popup = document.getElementById('labCertPopup');
    
    const closeBtn = popup ? popup.querySelector('.close-btn') : null;
    
    if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (popup) {
                popup.style.display = 'none';
                document.body.style.overflow = '';
                const originalContainer = popup.getAttribute('data-original-container');
                if (originalContainer) {
                    const container = document.querySelector(originalContainer);
                    if (container) {
                        container.appendChild(popup);
                    }
                }
            }
        });
    }

    if (popup) {
        popup.addEventListener('click', function(e) {
            if (e.target.classList.contains('popup-overlay')) {
                popup.style.display = 'none';
                document.body.style.overflow = '';
                const originalContainer = popup.getAttribute('data-original-container');
                if (originalContainer) {
                    const container = document.querySelector(originalContainer);
                    if (container) {
                        container.appendChild(popup);
                    }
                }
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function() {
    addEventListenersToPopup();
});

document.addEventListener('shopify:section:load', function() {
    addEventListenersToPopup();
});

function openPopup() {
    const popup = document.getElementById('labCertPopup');
    
    if (!popup) {
        console.warn('Popup element not found!');
        return;
    }

    if (!popup.getAttribute('data-original-container')) {
        popup.setAttribute('data-original-container', '.pf-nst010-description');
    }
    
    document.body.appendChild(popup);
    
    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';
}

function closePopup() {
    try {
        const popup = document.getElementById('labCertPopup');
        if (popup) {
            popup.style.display = 'none';
            document.body.style.overflow = '';
            
            const originalContainer = popup.getAttribute('data-original-container');
            if (originalContainer) {
                const container = document.querySelector(originalContainer);
                if (container) {
                    container.appendChild(popup);
                }
            }
        }
    } catch (error) {
        console.warn('Error closing popup:', error);
    }
}

window.openPopup = openPopup;
window.closePopup = closePopup; 